/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import "DesignSystem/Fonts/Inter-600.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsert/DocumentTemplate/Empty"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Document template"
 color={dtTysiainputlabelColorPrimaryBase}
 fontFamily="Inter"
 fontWeight={600}
 whiteSpace="nowrap"
 overflowX="hidden"
 textOverflow="ellipsis"
 marginBottom={8}
 fontSize={12}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Document templates not found"
/>
</div>
{children}
</React.Fragment>)
}